import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">IronQuill Consulting</div>
          <p className="footer-description">
            Strategic proposal development and capture support for government contractors, consulting firms, and startups pursuing competitive RFPs.
          </p>
          <div style={{ display: 'flex', gap: '16px', marginTop: '24px' }}>
            <a href="#" style={{ color: 'var(--text-muted)', transition: 'color 0.3s ease' }}>
              <Linkedin size={20} />
            </a>
            <a href="#" style={{ color: 'var(--text-muted)', transition: 'color 0.3s ease' }}>
              <Twitter size={20} />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul className="footer-links">
            <li><Link to="/services/proposal-development">Proposal Development</Link></li>
            <li><Link to="/services/capture-support">Capture Support</Link></li>
            <li><Link to="/services/proposal-management">Proposal Management</Link></li>
            <li><Link to="/services/proposal-design">Proposal Design</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <ul className="footer-links">
            <li><Link to="/about">About IronQuill</Link></li>
            <li><Link to="/process">Our Process</Link></li>
            <li><Link to="/case-studies">Case Studies</Link></li>
            <li><Link to="/free-assessment">Free Assessment</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact</h4>
          <ul className="footer-links">
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <Mail size={16} style={{ color: 'var(--gold-primary)' }} />
              <a href="mailto:info@ironquill.com">info@ironquillconsulting.com</a>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
              <Phone size={16} style={{ color: 'var(--gold-primary)' }} />
              <a href="tel:"></a>
            </li>
            <li style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
              <MapPin size={16} style={{ color: 'var(--gold-primary)', marginTop: '2px' }} />
              <span style={{ color: 'var(--text-muted)', fontSize: '14px' }}>
                J&K, India 
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 IronQuill Consulting. All rights reserved. | Professional Proposal Development Services</p>
      </div>
    </footer>
  );
}
